import { useState, useEffect } from 'react';
import { Plus, Trash2, Save, BarChart, Clock, Calendar, Filter, Settings, Edit, AlertTriangle, ChevronDown, ChevronUp, Search, OctagonAlert, Image } from 'lucide-react';
import {
  Package,
  X,
  SlidersHorizontal,
  Percent,
  Smartphone,
  ShoppingBag,
  Utensils,
  Sofa,
  Box,
  Circle,
  MoreHorizontal,
  SearchX,
  PenLine,
  IndianRupee,
  LayoutGrid,
  CalendarDays,
  CalendarCheck,
  Users,
  UserCheck,
  MapPin
} from 'lucide-react';

import Sidebar from '../../component/b2c/sidebar/sidebar';
import NavBar from '../../component/b2c/navBar/navBar';
import { useMyContext } from '../../context/MyContext';
import { Base_Url, setOffer } from '../../config/config';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export default function OfferSessionPanel() {
  const { isToggleSidebar, isDarkMode } = useMyContext();
  // const [offers, setOffers] = useState([
  //   { id: 1, threshold: 5000, discount: 5, category: "All", startDate: "2025-05-05", endDate: "2025-06-05", status: "active" },
  //   { id: 2, threshold: 10000, discount: 10, category: "shipment cashback", startDate: "2025-05-10", endDate: "2025-05-25", status: "scheduled" }
  // ]);
   
  const navigate = useNavigate();

  const [newOffer, setNewOffer] = useState({
    threshold: '',
    description: '',
    discountType: "Percentage",
    category: 'All',
    startDate: '',
    endDate: '',
    image: ''
  });

  const [editingId, setEditingId] = useState(null);
  const [savedMessage, setSavedMessage] = useState('');
  const [messageType, setMessageType] = useState('success');

  const [activeTab, setActiveTab] = useState('current');
  // const [analyticsData, setAnalyticsData] = useState({
  //   redemptions: 256,
  //   revenue: 127500,
  //   topOffer: '10% off orders above ₹10,000',
  //   savings: 12750
  // });

  const categories = ['All', 'shipment cashback'];

  // Set today's date as default start date when component mounts
  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    const nextMonth = new Date();
    nextMonth.setMonth(nextMonth.getMonth() + 1);

    setNewOffer(prev => ({
      ...prev,
      startDate: today,
      endDate: nextMonth.toISOString().split('T')[0]
    }));
  }, []);

  const validateForm = () => {
    const { threshold, discountType, startDate, endDate, description, image } = newOffer;

    if (!threshold || !discountType || !startDate || !endDate || !image || !description) {
      showMessage("Please fill all required fields", "error");
      return false;
    }
    const thresholdValue = parseFloat(threshold);

    if (new Date(startDate) > new Date(endDate)) {
      showMessage("End date must be after start date", "error");
      return false;
    }

    return true;
  };

  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');

  const addOffer = async () => {
    if (!validateForm()) return;

    const thresholdValue = parseFloat(newOffer.threshold);
    // const discountValue = parseFloat(newOffer.discount);
    try { 
      // Prepare form data
      const formData = new FormData();
      formData.append('category', newOffer.category);
      formData.append('discount_type', newOffer.discountType);
      formData.append('discount_value', thresholdValue);
      formData.append('description', newOffer.description);

      // Format dates to DD/MM/YYYY format
      const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      };

      formData.append('start_date', formatDate(newOffer.startDate));
      formData.append('end_date', formatDate(newOffer.endDate));

      // Append image if available
      if (newOffer.image) {
        formData.append('image', newOffer.image);
      }

      // Make API call
      const response = await fetch(Base_Url + setOffer, {
        method: 'POST',
        headers: {
          "cus_id": cus_id,
          "token": token,
          //   'Content-Type': 'multipart/form-data',
        },
        body: formData
      });

      const result = await response.json();
      if (result.status === "SUCCESS") {
        toast.success(result.message);
       navigate('/dashboard')
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error("Failed to add offer. Please try again.", "error");
    }
  };

  const showMessage = (message, type = 'success') => {
    setSavedMessage(message);
    setMessageType(type);

    // Clear message after 3 seconds
    setTimeout(() => {
      setSavedMessage('');
    }, 3000);
  };

  // const toggleAdvancedOptions = () => {
  //   setIsAdvancedVisible(!isAdvancedVisible);
  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewOffer(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const getStatusClass = (status) => {
    switch (status) {
      case 'active':
        return 'bg-green-100 text-green-800';
      case 'scheduled':
        return 'bg-blue-100 text-blue-800';
      case 'expired':
        return 'bg-gray-100 text-gray-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  // const filteredOffers = offers.filter(offer => {
  //   // Apply category filter
  //   if (filterCategory !== 'All' && offer.category !== filterCategory) return false;

  //   // Apply status filter
  //   if (filterStatus !== 'All' && offer.status !== filterStatus) return false;

  //   // Apply search
  //   if (searchTerm && !`${offer.threshold} ${offer.discount}% ${offer.category}`.toLowerCase().includes(searchTerm.toLowerCase())) return false;

  //   return true;
  // });

  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
      <div className="z-10">
        <NavBar />
      </div>

      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
            style={
              window.innerWidth < 768
                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                : {}
            }>
            <Sidebar />
          </div>
        )}

        <div className="flex-1 bg-gray-100 overflow-y-auto p-6">
          <div className="max-w-7xl mx-auto">
            {/* Header with animated gradient border */}
            <div className="relative mb-8 pb-2">
              <div className="flex items-center">
                <div className="p-3 rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600 text-white mr-4 shadow-lg">
                  <Package size={24} />
                </div>
                <h2 className="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-700 to-indigo-800 dark:from-blue-400 dark:to-indigo-300">
                  Logistics Offer Management
                </h2>
              </div>
              <div className="absolute bottom-0 left-0 h-1 w-full bg-gradient-to-r from-blue-500 via-indigo-500 to-transparent rounded"></div>
            </div>

            {/* Custom Tabs with Animation */}
            <div className="flex mb-8 border-b border-gray-200 dark:border-gray-700 relative">
              {['current'].map((tab) => (
                <button
                  key={tab}
                  className={`px-6 py-3 font-medium transition-all duration-200 relative ${activeTab === tab
                    ? 'text-blue-600 dark:text-blue-400 font-semibold'
                    : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
                    }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)} Offers
                  {activeTab === tab && (
                    <div className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-t transform scale-x-100 transition-transform origin-bottom"></div>
                  )}
                </button>
              ))}
            </div>

            {activeTab === 'current' && (
              <>
                {/* Add/Edit Offer Form with Enhanced Design */}
                <div className="bg-white dark:bg-darkmodeColor text-gray-700 dark:text-white rounded-xl shadow-xl p-6 mb-8 border border-gray-100 ">
                  <div className="flex items-center mb-6">
                    <div className="p-2 bg-blue-100 dark:bg-blue-900/40 text-blue-600 dark:text-blue-400 rounded-lg mr-3">
                      {editingId ? <PenLine size={20} /> : <Plus size={20} />}
                    </div>
                    <h3 className="text-xl font-semibold text-gray-800 dark:text-white">
                      {editingId ? 'Edit Offer' : 'Create New Offer'}
                    </h3>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

                    <div className="group">
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 group-focus-within:text-blue-600 dark:group-focus-within:text-blue-400 transition-colors">
                        Discount *
                      </label>

                      <div className="flex gap-3">
                        {/* Dropdown for Discount Type */}
                        <div className="relative w-1/2">
                          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                            {/* <Percent size={18} className="text-gray-400 dark:text-gray-500 group-focus-within:text-blue-500" /> */}
                          </div>
                          <select
                            name="discountType"
                            value={newOffer.discountType}
                            onChange={handleInputChange}
                            className="w-full border rounded-custom shadow-custom-light dark:shadow-custom-dark border-gray-300 rounded-lg pl-10 pr-10 py-3 appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-600 dark:bg-darkmodeColor  dark:text-white transition-all"
                          >
                            <option value="Percentage">Percentage</option>
                            <option value="Flat">Flat</option>
                          </select>
                          <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                            <ChevronDown size={18} className="text-gray-400 dark:text-gray-500" />
                          </div>
                        </div>

                        {/* Input for Discount Value */}
                        <div className="relative w-1/2">
                          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                            {newOffer.discountType === "Percentage" ? (
                              <Percent size={18} className="text-gray-400 dark:text-white" />
                            ) : (
                              <IndianRupee size={18} className="text-gray-400 dark:text-white" />
                            )}
                          </div>
                          <input
                            type="number"
                            name="threshold"
                            value={newOffer.threshold}
                            onChange={handleInputChange}
                            placeholder={newOffer.discountType === "Percentage" ? "E.g. 10" : "E.g. 500"}
                            min="0"
                            max={newOffer.discountType === "Percentage" ? "100" : undefined}
                            className="w-full border rounded-custom shadow-custom-light dark:shadow-custom-dark border-gray-300  rounded-lg pl-10 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-darkmodeColor dark:text-white transition-all"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="group">
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 group-focus-within:text-blue-600 dark:group-focus-within:text-blue-400 transition-colors">
                        Category *
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                          <LayoutGrid size={18} className="text-gray-400 dark:text-gray-500 group-focus-within:text-blue-500" />
                        </div>
                        <select
                          name="category"
                          value={newOffer.category}
                          onChange={handleInputChange}
                          className="w-full border rounded-custom shadow-custom-light dark:shadow-custom-dark border-gray-300 rounded-lg pl-10 pr-10 py-3 appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-darkmodeColor dark:text-white transition-all"
                        >
                          {categories.filter(category => category !== 'All').map(category => (
                            <option key={category} value={category}>{category}</option>
                          ))}
                        </select>
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                          <ChevronDown size={18} className="text-gray-400 dark:text-gray-500" />
                        </div>
                      </div>
                    </div>

                    <div className="group">
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 group-focus-within:text-blue-600 transition-colors">
                        Start Date *
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                          <CalendarDays size={18} className="text-gray-400 dark:text-white group-focus-within:text-blue-500" />
                        </div>
                        <input
                          type="date"
                          name="startDate"
                          value={newOffer.startDate}
                          onChange={handleInputChange}
                          className="w-full border rounded-custom shadow-custom-light dark:shadow-custom-dark border-gray-300 rounded-lg pl-10 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-darkmodeColor dark:text-white transition-all"
                        />
                      </div>
                    </div>

                    <div className="group">
                      <label className="block text-sm font-medium text-gray-700 dark:text-white mb-2 group-focus-within:text-blue-600 transition-colors">
                        End Date *
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                          <CalendarCheck size={18} className="text-gray-400 dark:text-white group-focus-within:text-blue-500" />
                        </div>
                        <input
                          type="date"
                          name="endDate"
                          value={newOffer.endDate}
                          onChange={handleInputChange}
                          className="w-full rounded-custom shadow-custom-light dark:shadow-custom-dark border border-gray-300 dark:bg-darkmodeColor rounded-lg pl-10 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500  dark:text-white transition-all"
                        />
                      </div>
                    </div>
                    <div className="group">
                      <label className="block text-sm font-medium text-gray-700 dark:text-white mb-2 group-focus-within:text-blue-600 transition-colors">
                        Description
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                          <IndianRupee size={18} className="text-gray-400 dark:text-white group-focus-within:text-blue-500" />
                        </div>
                        <input
                          type="text"
                          name="description"
                          value={newOffer.description}
                          onChange={handleInputChange}
                          placeholder="text"
                          className="w-full rounded-custom shadow-custom-light dark:shadow-custom-dark border border-gray-300  rounded-lg pl-10 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-darkmodeColor dark:text-white transition-all"
                        />
                      </div>
                    </div>

                    <div className="group">
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 group-focus-within:text-blue-600 dark:group-focus-within:text-blue-400 transition-colors">
                        Offer Image
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                          <Image size={18} className="text-gray-400 dark:text-white group-focus-within:text-blue-500" />
                        </div>
                        <input
                          type="file"
                          name="image"
                          accept="image/*"
                          onChange={(e) =>
                            setNewOffer({ ...newOffer, image: e.target.files[0] })
                          }
                          className="w-full rounded-custom shadow-custom-light dark:shadow-custom-dark border border-gray-300 rounded-lg pl-10 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-darkmodeColor dark:text-white transition-all file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 dark:file:bg-blue-900/30 dark:file:text-blue-400"
                        />
                      </div>

                      {/* Optional: Preview the selected image */}
                      {newOffer.image && (
                        <div className="mt-3">
                          <img
                            src={URL.createObjectURL(newOffer.image)}
                            alt="Preview"
                            className="w-32 h-32 object-cover rounded-lg border border-gray-300 "
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="mt-8 flex justify-end">
                    <button
                      onClick={addOffer}
                      className="px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-medium rounded-lg transition-all shadow-lg hover:shadow-xl flex items-center"
                    >
                      <Plus size={18} className="mr-2" /> Add Offer
                    </button>

                  </div>
                </div>

                {/* Save All Button with Animation */}
                {/* <div className="flex justify-center mb-8">
                  <button
                    onClick={saveOffers}
                    className="group px-8 py-3.5 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-medium rounded-xl hover:from-blue-700 hover:to-indigo-700 flex items-center shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-1"
                  >
                    <Save size={20} className="mr-2" /> Save All Changes
                  </button>
                </div> */}
              </>
            )}


            {/* Notification */}
            {savedMessage && (
              <div className={`fixed bottom-4 right-4 p-4 rounded-lg shadow-lg flex items-center ${messageType === 'success' ? 'bg-green-100 text-green-800 border-l-4 border-green-500' :
                'bg-red-100 text-red-800 border-l-4 border-red-500'
                }`}>
                {messageType === 'success' ? (
                  <Save size={20} className="mr-2" />
                ) : (
                  <AlertTriangle size={20} className="mr-2" />
                )}
                {savedMessage}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}